"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shades = void 0;
var _react = require("react");
var _internal = require("../../../hooks/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Shades = () => {
  const {
    currentProduct: {
      shades
    },
    currentShade: {
      canBeSold,
      color: {
        name,
        hexColors,
        imageUrl
      },
      productCode
    },
    setCurrentShadeCode
  } = (0, _internal.useProduct)();
  // istanbul ignore next @preserve -- No need to test fallback
  const formattedName = name ?? '';
  const currentShade = (0, _react.useMemo)(() => ({
    productCode,
    canBeSold,
    hexColors,
    imageUrl,
    name: formattedName
  }), [canBeSold, formattedName, hexColors, imageUrl, productCode]);
  const parsedShades = shades.map(shade => ({
    productCode: shade.productCode,
    canBeSold: shade.canBeSold,
    hexColors: shade.color.hexColors,
    imageUrl: shade.color.imageUrl,
    name: shade.color.name ?? ''
  }));
  if (parsedShades.length < 2) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ShadesAndDetails, {
    currentShade: currentShade,
    setCurrentShadeProductCode: setCurrentShadeCode,
    shades: parsedShades
  });
};
exports.Shades = Shades;
